import * as routes from '@educabot/educablocks-cosmos';

export const URLS = {
  BLOCKS_SERVICE: routes.educablocksUri,
};
